export const REFUND_REASON_OPTIONS = [
	{ id: 'User Ticket Refund', label: 'User Ticket Refund' },
	{ id: 'Collusion Refund', label: 'Collusion Refund' },
	{ id: 'GoodWill Refund', label: 'GoodWill Refund' },
	{ id: 'App Downtime', label: 'App Downtime' },
	{ id: 'Tech Sheet Refund', label: 'Tech Sheet Refund' },
	{ id: 'Other Technical issues', label: 'Other Technical issues' },
	{ id: 'Others', label: 'Others' }
];
